import { styled } from '@mui/material/styles';

import Base02Container from 'src/components/Base02Container';
import BottomSheet from 'src/components/BottomSheet';

export const Container = styled('div')({
  height: '100%',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  padding: '4rem ',
  overflow: 'hidden',
});

export const ContentsContainer = styled('div')({});

export const VoteContainer = styled(Base02Container)({
  width: '100%',
  height: '100%',

  display: 'flex',
  flexDirection: 'column',

  padding: '2.4rem',
});

export const VoteTopContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  paddingBottom: '1.6rem',

  borderBottom: `0.1rem solid ${theme.colors.base05}`,

  color: theme.colors.base01,

  rowGap: '0.8rem',
}));

export const ProposalTitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base01,

  maxWidth: '45rem',

  wordBreak: 'keep-all',
  whiteSpace: 'nowrap',

  '& > *': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export const ProposalTitleWrapperContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base01,
}));

export const VoteBodyContainer = styled('div')({});

export const VoteBodyDescriptionContainer = styled('div')(({ theme }) => ({
  marginTop: '1.6rem',

  color: theme.colors.base02,
}));

export const DescriptionContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,

  WebkitLineClamp: 4,
  WebkitBoxOrient: 'vertical',

  width: '100%',
  display: '-webkit-box',

  wordWrap: 'break-word',

  overflow: 'hidden',
}));

export const VoteBodyDescriptionShowButton = styled('button')({
  width: '100%',

  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',

  margin: '0.6rem 0 2rem',

  padding: 0,

  border: 0,

  color: '#69A5FF',

  backgroundColor: 'transparent',

  cursor: 'pointer',

  columnGap: '0.4rem',

  '&:hover': {
    opacity: 0.8,
  },
});

export const ArrowIconContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const VoteOptionButtonContainer = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: 'repeat(2, 1fr)',

  gap: '0.8rem',
});

export const StyledBottomSheet = styled(BottomSheet)({
  '& .MuiPaper-root': {
    height: '71rem',
    position: 'absolute',
    bottom: '0',
  },
});

export const IconContainer = styled('div')({
  width: '4.8rem',
  height: '4.8rem',

  '& > svg': {
    width: '4.8rem',
    height: '4.8rem',
  },
});

export const DetailContainer = styled('div')({
  width: 'calc(100% - 8rem)',

  position: 'absolute',
  bottom: '12.4rem',
});

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  flexShrink: 0,

  marginBottom: '2.6rem',
});

export const HeaderTitle = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

type WrapperContainerProps = {
  'data-is-open': boolean;
};

export const WrapperContainer = styled('div')<WrapperContainerProps>((props) => ({
  position: 'absolute',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',

  display: props['data-is-open'] ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '1',
  overflowY: 'auto',

  backgroundColor: 'rgba(0, 0, 0, 0.6)',

  borderRadius: '2rem',
}));

export const Base02Text = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));
